import { render, staticRenderFns } from "./HowToForm.vue?vue&type=template&id=485d2de2&"
import script from "./HowToForm.vue?vue&type=script&lang=js&"
export * from "./HowToForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports